import {CommonModule} from "@angular/common";
import {AfterViewInit, Component, Inject, ViewChild} from '@angular/core';
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatButtonModule} from "@angular/material/button";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatPaginator, MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {MatTableDataSource, MatTableModule} from "@angular/material/table";
import {displayString} from "@ui-kit/framework/util/static/string-format-util";
import {UploadResponse} from "../csv-import.model";

@Component({
  selector: 'app-csv-import-report',
  standalone: true,
  imports: [CommonModule, MatIconModule, FlexLayoutModule, MatButtonModule,
  MatFormFieldModule, MatInputModule, MatTableModule, MatSortModule, MatPaginatorModule],
  templateUrl: './csv-import-report.component.html',
  styleUrls: ['./csv-import-report.component.scss']
})
export class CsvImportReportComponent implements AfterViewInit {
  @ViewChild('paginator') paginator!: MatPaginator;

  dataSource = new MatTableDataSource<string>();
  report!: UploadResponse;
  pageSize: number = 5;

  displayedColumns = ['item', 'message'];

  constructor(public dialogRef: MatDialogRef<CsvImportReportComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { uploadReport: UploadResponse }) {
    this.report = data.uploadReport;
    this.dataSource = new MatTableDataSource<string>(data.uploadReport.errorsMessages);
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.pageSize = this.pageSize;
      this.dataSource.paginator = this.paginator;
    }
  }

  getItem(msg: string) {
    const startIndex = msg.indexOf('[');
    const endIndex = msg.indexOf(']');

    if (startIndex !== -1 && endIndex !== -1 && endIndex > startIndex) {
      return msg.slice(startIndex + 1, endIndex).trim();
    } else {
      return null;
    }
  }

  getMessage(msg: string) {
    const startIndex = msg.indexOf('[');
    const endIndex = msg.indexOf(']');

    if (startIndex !== -1 && endIndex !== -1 && endIndex > startIndex) {
      return msg.slice(endIndex + 2).trim();
    } else {
      return null;
    }
  }

  close() {
    this.dialogRef.close();
  }

  protected readonly displayString = displayString;
}
